import styled from "styled-components"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"

export default styled(Button)`
  display: block;
  margin: 0 auto;
  margin-bottom: ${padding.base};
`
